import React from 'react';
import styled from 'styled-components';

import Cell from './common/Cell';
import DataCell from './common/DataCell';
import MonitorField from './common/MonitorField';
import MonitorLabel from './common/MonitorLabel';
import Row from './common/Row';

export interface ILinkStatusAreaProps {}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export default function LinkStatusArea(props: ILinkStatusAreaProps) {
  return (
    <Container>
      <Row>
        <Cell width="40%">
          <MonitorLabel field="link-status-area-1" />
        </Cell>
        <DataCell width="60%">
          <MonitorField field="link-status-area-1" />
        </DataCell>
      </Row>
      <Row>
        <Cell width="40%">
          <MonitorLabel field="link-status-area-2" />
        </Cell>
        <DataCell width="60%">
          <MonitorField field="link-status-area-2" />
        </DataCell>
      </Row>
    </Container>
  );
}
